import React from 'react';

const Alert = ({ msg, error = false, success = false, close, className = '' }) => {
    return (
        <div className='alert' onClick={close}>
            <div
                className={`alert--content${error ? ' error' : ''}${success ? ' success' : ''} ${className}`}
                onClick={(e) => e.stopPropagation()}
            >
                {msg}
                {
                    error &&
                    <div className='err-btn' onClick={close}>OK</div>
                }
            </div>
        </div>
    )
}

export default Alert;